var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      ref: "list",
      class: { fill: _vm.fill },
      attrs: { id: "list" },
      on: {
        scroll: function($event) {
          _vm.scrolled.bind(_vm.list)($event)
        }
      }
    },
    [
      _vm.flip
        ? _c(
            "div",
            { staticClass: "end-state" },
            [
              !_vm.list.loaded ||
              (_vm.list.loaded && !_vm.list.noMoreItems && _vm.lazy)
                ? _c("v-progress-circular", {
                    staticStyle: { margin: "0 auto" },
                    attrs: { indeterminate: "", color: "primary", size: 40 }
                  })
                : _vm.list.loaded && !_vm.list.noMoreItems && !_vm.lazy
                  ? _c(
                      "v-btn",
                      {
                        staticStyle: { margin: "0 auto" },
                        attrs: { color: "primary", loading: _vm.list.lockout },
                        on: { click: _vm.loadMore }
                      },
                      [_vm._v("Load More")]
                    )
                  : [
                      _vm.endState
                        ? _c("vo-list-footer", { attrs: { list: _vm.list } })
                        : _vm._e()
                    ]
            ],
            2
          )
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "list-container" },
        _vm._l(_vm.list.items, function(item, i) {
          return _vm.list.items
            ? _c(
                "div",
                {
                  key: "listItem" + i,
                  staticClass: "list-item",
                  class: { cursor: _vm.selectable },
                  on: {
                    click: function($event) {
                      _vm.itemSelected(item)
                    }
                  }
                },
                [
                  item
                    ? [
                        _vm.itemComponent
                          ? [
                              _c(_vm.itemComponent, {
                                tag: "component",
                                staticClass: "list-component",
                                attrs: {
                                  "v-ripple": _vm.selectable,
                                  item: item,
                                  selected: _vm.selected
                                }
                              })
                            ]
                          : _vm._e(),
                        _vm._v(" "),
                        _vm._t("itemSlot", null, { item: item, i: i })
                      ]
                    : _vm._e()
                ],
                2
              )
            : _vm._e()
        })
      ),
      _vm._v(" "),
      !_vm.flip
        ? _c(
            "div",
            { staticClass: "end-state" },
            [
              !_vm.list.loaded ||
              (_vm.list.loaded && !_vm.list.noMoreItems && _vm.lazy)
                ? _c("v-progress-circular", {
                    staticStyle: { margin: "0 auto" },
                    attrs: { indeterminate: "", color: "primary", size: 40 }
                  })
                : _vm.list.loaded && !_vm.list.noMoreItems && !_vm.lazy
                  ? _c(
                      "v-btn",
                      {
                        staticStyle: { margin: "0 auto" },
                        attrs: { color: "primary", loading: _vm.list.lockout },
                        on: { click: _vm.loadMore }
                      },
                      [_vm._v("Load More")]
                    )
                  : [
                      _vm.endState
                        ? _c("vo-list-footer", { attrs: { list: _vm.list } })
                        : _vm._e()
                    ]
            ],
            2
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-264bddce", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-264bddce","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/List.vue
// module id = 509
// module chunks = 4